// Promo-source persistence (the `s` tag /pay forwards to the backend).
//
// Mirrors the offer test's containment-is-state approach: a promo landing
// page (e.g. /alw) stores its source once on mount, and /pay falls back to
// the stored value when its own URL carries no explicit ?s=. That way the
// tag survives detours through nav pages whose CTAs don't carry query
// params, and a promoted cohort can't silently leak into the untagged
// control stats. An explicit ?s= on /pay always wins over the stored value.
const SOURCE_KEY = 'ssi_source';

export function storeSource(source) {
  try { sessionStorage.setItem(SOURCE_KEY, source); } catch (e) { /* ignore */ }
}

export function getStoredSource() {
  try { return sessionStorage.getItem(SOURCE_KEY); } catch (e) { return null; }
}
